import APP from 'src/main.js'
import AppRecord from './AppRecord.js'
class DocumentPrivilege extends AppRecord {
  get document(){
    return this.constructor.employeeStore.documents.find(doc => doc.id === this.document_id)
  }
  get user(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.user_id)
  }
  get user_name(){
    if(this._user_name){return this._user_name}
    if(this.user && this.user.person){
      this._user_name = this.user.person_name
      return this._user_name
    } else {
      return undefined
    }
  }
  get filename(){
    if(this._filename){return this._filename}
    if(this.document){
      this._filename = this.document.filename
      return this._filename
    } else {
      return undefined
    }
  }
  get key(){
    return `${this.id}-${this.document_id}-${this.new_id}`
  }
  get valid(){
    return (this.role||this.user_id)&&this.rightGranted&&!this.roleTaken&&!this.userIdTaken
  }
  get rightGranted(){
    return this.read||this.write||this.grant||this.purge||this.admin
  }
  get roleTaken(){
    if(!this.role){
      return false
    }
    return this.document.document_privileges.filter((priv) => {
      return priv.role == this.role
    }).length > 1
  }
  get userIdTaken(){
    if(!this.user_id){
      return false
    }
    return this.document?.document_privileges.filter((priv) => {
      return priv.user_id == this.user_id
    }).length > 1
  }
}
export default DocumentPrivilege
